import { NgModule } from '@angular/core';

import { ToastModule } from '@libs/src/toast/toast.module';

import { GroupMembersDownloadService } from './group-members-download.service';
import { GroupsBackend } from '@libs/src/groups/groups.backend';

@NgModule({
  imports: [ToastModule],
  providers: [GroupMembersDownloadService, GroupsBackend],
})
export class GroupMembersDownloadModule {}
